import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import ChevronUp from './assets/chevronUp.svg?react';
import ChevronDown from './assets/chevronDown.svg?react';
import MathContent from '../../math-content';
import propTypes from 'prop-types';

const Container = styled.div`
    border: 2px solid var(--gray200);
    border-radius: 4px;

    width: 100%;
    padding-bottom: calc(var(--space-unit) * 2);

    img {
        vertical-align: middle;
        height: auto !important;
        max-width: 100%;
    }
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;

    color: var(--gray200);
    background-color: var(--gray200);

    height: 40px;
    margin-bottom: calc(var(--space-unit) * 2);
`;

const Label = styled.span`
    color: var(--gray800);
    font-size: calc(var(--space-unit) * 2);
    font-weight: 600;

    margin: 8px 0 8px 20px;
`;

const Body = styled.div`
    color: var(--gray800);
    overflow: hidden;
    height: ${(props) => (props.isOpened ? 'fit-content' : '116px')};
    margin: 8px 20px 8px 20px;
`;

export const CollapseButton = styled.button`
    display: flex;

    background-color: var(--color-white);
    border: 1px solid var(--gray200);
    border-radius: 4px;

    height: 36px;
    width: fit-content;
    left: 0;
    right: 0;
    margin-top: -19px;
    margin-left: auto;
    margin-right: auto;
    padding: 0;

    cursor: pointer;
`;

const ButtonContent = styled.div`
    display: flex;
    align-items: center;
    height: 34px;
    padding: 0 12px;

    color: var(--blue500);
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;

    & > svg {
        width: calc(var(--space-unit) * 2);
        height: calc(var(--space-unit) * 2);
        margin-right: var(--space-unit);
        fill: var(--blue500);
    }
`;

export const SharedTextContent = ({ title, publicTitle, content, showExpandButton = false, isUnitutor, isDefaultOpen = false }) => {
    const [isOpened, setIsOpened] = useState(isDefaultOpen);
    const [isEllipsed, setIsEllipsed] = useState(true);
    const sharedTextContent = useCallback(
        (node) => node && setIsEllipsed(node.offsetHeight < node.scrollHeight || showExpandButton),
        [showExpandButton],
    );
    return (
        <>
            <Container isOpen={isOpened}>
                <Header>
                    <Label>{title}</Label>
                </Header>
                {isUnitutor && <Label>{publicTitle}</Label>}
                <Body ref={sharedTextContent} isOpened={isOpened}>
                    <MathContent>{content}</MathContent>
                </Body>
            </Container>
            {isEllipsed && (
                <CollapseButton onClick={() => setIsOpened(!isOpened)}>
                    <ButtonContent>
                        {isOpened ? <ChevronUp /> : <ChevronDown />}
                        <span>{isOpened ? 'Leggi meno' : 'Leggi tutto'}</span>
                    </ButtonContent>
                </CollapseButton>
            )}
        </>
    );
};

SharedTextContent.propTypes = {
    title: propTypes.string.isRequired,
    publicTitle: propTypes.string,
    content: propTypes.string.isRequired,
    isUnitutor: propTypes.bool,
    showExpandButton: propTypes.bool,
    isDefaultOpen: propTypes.bool,
};
